import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'zr-tabs',
  template: `
      <!-- line-tabs -->
      <ul *ngIf="tabsType==='line-tabs'" [ngClass]="{'m-tabs-line--2x':bootomBorder2X}" class="nav nav-tabs  m-tabs-line {{colorThemeStyle}}"
        role="tablist">
        <li *ngFor="let tabs of tabsData;let i=index" [ngClass]="{'dropdown':tabs.dropdown}" class="nav-item m-tabs__item">
          <a *ngIf="!tabs.dropdown" [ngClass]="{'disabled':tabs.disabled,'active':i===choice}" (click)="selectedItem(tabs)" class="nav-link m-tabs__link lz-tabs-item"
            data-toggle="tab">
            <i *ngIf="tabs.icon" class="{{tabs.icon}}"></i>
            <span>{{tabs.text}}</span>
          </a>
          <a *ngIf="tabs.dropdown" [ngClass]="{'disabled':tabs.disabled,'active':i===choice}" class="nav-link m-tabs__link dropdown-toggle"
            data-toggle="dropdown">
            <i *ngIf="tabs.icon" class="{{tabs.icon}}"></i>
            <span>{{tabs.text}}</span>
          </a>
          <div *ngIf="tabs.dropdown" class="dropdown-menu">
            <a *ngFor="let dropdown of tabs.dropdownArray" (click)="selectedItem(dropdown)" class="dropdown-item" data-toggle="tab">{{dropdown.text}}</a>
          </div>
        </li>
      </ul>
      <!-- bootstrap-line-tabs -->
      <ul *ngIf="tabsType==='bootstrap-line-tabs'" class="nav nav-tabs nav-fill" role="tablist">
        <li *ngFor="let tabs of tabsData;let i=index" [ngClass]="{'dropdown':tabs.dropdown}" class="nav-item">
          <a *ngIf="!tabs.dropdown" [ngClass]="{'disabled':tabs.disabled,'active':i===choice}" (click)="selectedItem(tabs)" class="nav-link"
            data-toggle="tab">
            <i *ngIf="tabs.icon" class="{{tabs.icon}} {{iconColor}}"></i>
            <span>{{tabs.text}}</span>
          </a>
          <a *ngIf="tabs.dropdown" [ngClass]="{'disabled':tabs.disabled,'active':i===choice}" class="nav-link dropdown-toggle" data-toggle="dropdown">
            <i *ngIf="tabs.icon" class="{{tabs.icon}} {{iconColor}}"></i>
            <span>{{tabs.text}}</span>
          </a>
          <div *ngIf="tabs.dropdown" class="dropdown-menu">
            <a *ngFor="let dropdown of tabs.dropdownArray" (click)="selectedItem(dropdown)" class="dropdown-item" data-toggle="tab">{{dropdown.text}}</a>
          </div>
        </li>
      </ul>
      <!-- bootstrap-btn-tabs -->
      <ul *ngIf="tabsType==='bootstrap-btn-tabs'" class="nav nav-pills {{btnColor}}" role="tablist">
        <li *ngFor="let tabs of tabsData;let i=index" [ngClass]="{'dropdown':tabs.dropdown}" class="nav-item">
          <a *ngIf="!tabs.dropdown" [ngClass]="{'disabled':tabs.disabled,'active':i===choice}" (click)="selectedItem(tabs)" class="nav-link"
            data-toggle="tab">
            <i *ngIf="tabs.icon" class="{{tabs.icon}}"></i>
            <span>{{tabs.text}}</span>
          </a>
          <a *ngIf="tabs.dropdown" [ngClass]="{'disabled':tabs.disabled,'active':i===choice}" class="nav-link dropdown-toggle" data-toggle="dropdown"
            role="button">
            <i *ngIf="tabs.icon" class="{{tabs.icon}}"></i>
            <span>{{tabs.text}}</span>
          </a>
          <div *ngIf="tabs.dropdown" class="dropdown-menu">
            <a *ngFor="let dropdown of tabs.dropdownArray" (click)="selectedItem(dropdown)" class="dropdown-item" data-toggle="tab">{{dropdown.text}}</a>
          </div>
        </li>
      </ul>`
})

export class ZrTabsComponent implements OnInit {
  @Input() tabsData: any[] = []; // data
  // tabs is type [line-tabs，bootstrap-line-tabs,bootstrap-btn-tabs]default line-tabs
  @Input() tabsType?: string = 'line-tabs';
  // when'line-tabs'is available, set the active border to the rough border.
  @Input() bootomBorder2X?: boolean = false;
  // when'line-tabs'is available, set the font color of item
  @Input() colorThemeStyle?: string = 'm-tabs-line--primary';
  // when'bootstrap-btn-tabs'is available, set the color of btn.
  @Input() btnColor?: string = 'nav-pills--success';
  // when'bootstrap-tabs'is available, set the color of Icon
  @Input() iconColor?: string = 'm--font-brand';
  // setting the default load to activate the number of tab
  @Input() choice?: number = 0;

  @Output() selected = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.defaultSelection(this.tabsData, this.choice);
  }

  selectedItem(event: any) {
    if (event.dropdown || event.disabled) {
      return;
    }
    this.selected.emit(event);
  }

  defaultSelection(arr: any[], choice: any) {
    arr.forEach((item, index) => {
      if (choice === index) {
        this.selectedItem(item);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/zr-tabs/zr-tabs.component.ts